export const IkeProviderType = {
	BEARING_BACK: 'backbearing' as const,
	BEARING: 'bearing' as const,
	EXISTING_SPAN: 'existingspan' as const,
	GPS: 'gps' as const,
	MANUAL: 'manual' as const,
	EDITED: 'edited' as const,
	POINT_TO_POINT: 'pointtopoint' as const,
	SAG: 'sag' as const,
	COLLECTION: 'collection' as const,
};

/**
 * Type of provided values for Collections
 */
export type IkeProviderType =
	| typeof IkeProviderType.BEARING
	| typeof IkeProviderType.BEARING_BACK
	| typeof IkeProviderType.EXISTING_SPAN
	| typeof IkeProviderType.GPS
	| typeof IkeProviderType.MANUAL
	| typeof IkeProviderType.EDITED
	| typeof IkeProviderType.POINT_TO_POINT
	| typeof IkeProviderType.COLLECTION
	| typeof IkeProviderType.SAG;
